

const baseUrl = 'https://bensburrito.com/'
// ENDPOINTS
const generateSessionIDURL = 'sessionId';
const getMenuURL = 'menus/'
const getItemDetailsURL = 'menus/getItemDetails/'
const placeOrderURL = 'myOrders/'
const getSpecialDealURL = 'specialdeal'


export const burritoAPIs = { 

    // Api call for generateSessionID
    generateSessionID() {           
        const generateSessionIDURLEndPoint = baseUrl + generateSessionIDURL;
        return fetch(generateSessionIDURLEndPoint, {
            method: 'GET',
            headers: {               
                "Content-Type": "application/json",

                
            },
        })
            .then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => response
            );
    },

    getLocationID() {           
        const getLocationEndPoint = baseUrl + 'locations';
         return fetch(getLocationEndPoint, {
            method: 'GET',
            headers: {               
                "Content-Type": "application/json",
            },
        })
            .then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => response
            );
    },

        // Api call for getMenu
        getMenu() { 
            console.log(baseUrl + getMenuURL + localStorage.getItem('locationID'))          
             const getMenuURLEndPoint = baseUrl + getMenuURL + localStorage.getItem('locationID');
            //const getMenuURLEndPoint = baseUrl + getMenuURL;
            return fetch(getMenuURLEndPoint, {
                method: 'GET',
                headers: {               
                    "Content-Type": "application/json",
                },
            })
                .then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => response
                );
        },

        // Api call for getItemDetails
        getItemDetails(itemID) {           
            const getItemDetailsURLEndPoint = baseUrl + getItemDetailsURL + itemID;
            return fetch(getItemDetailsURLEndPoint, {
                method: 'GET',
                headers: {               
                    "Content-Type": "application/json",
                },
            })
                .then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => response
                );
        },

    // Api call for placeORder
    placeOrder(paramData) {
        console.log('paramdata is', paramData)       
        const placeOrderURLEndPoint = baseUrl + placeOrderURL + localStorage.getItem('sessionID');
        console.log(placeOrderURLEndPoint)
        return fetch(placeOrderURLEndPoint, {
            method: 'POST',
            headers: {  
                "Content-Type": "application/json",               
            },
            body: JSON.stringify(paramData)
        })
            .then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => response
            );
    },

     // Api call for GET SPECIAL DEAL
    getSpecialDeal() { 
        console.log(baseUrl + getSpecialDealURL + localStorage.getItem('locationID'))          
            const getSpecialDealURLEndPoint = baseUrl + getSpecialDealURL;
        //const getSpecialDealURLEndPoint = baseUrl + getSpecialDealURL;
        return fetch(getSpecialDealURLEndPoint, {
            method: 'GET',
            headers: {               
                "Content-Type": "application/json",
            },
        })
            .then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => response
            );
    },

}